import type { PrimeVueLocaleOptions } from 'primevue/config'
import { primeVueEs } from './es'

/**
 * Builds the locale PrimeVue should use, layered over its own shipped English
 * defaults rather than replacing them. Replacing outright would blank every
 * key this project did not think to translate — and the missing ones would be
 * invisible, because a component with no string simply renders nothing.
 *
 * English needs no file of its own: it IS PrimeVue's default, so the base is
 * returned untouched. A second English catalogue would only be one more thing
 * to keep in step with upstream.
 */
export const primeVueLocaleFor = (
  locale: string,
  base: PrimeVueLocaleOptions,
): PrimeVueLocaleOptions => {
  if (!locale.startsWith('es')) {
    return base
  }

  // `aria` is merged one level deeper on purpose: a shallow spread would drop
  // every aria label not listed in es.ts, and those labels are the only name a
  // screen reader has for the paginator's icon-only buttons.
  return {
    ...base,
    ...primeVueEs,
    aria: { ...base.aria, ...primeVueEs.aria },
  }
}
